export default {
  SET_BREADCRUMBS: '@@breadcrumbs/SET_BREADCRUMBS',
  CLEAR_BREADCRUMBS: '@@breadcrumbs/CLEAR_BREADCRUMBS',
};
